import React from 'react';

interface NeedToKnowProps {
  info: [string] | string[];
  heading: string;
  showTimeline?: boolean;
}

export const NeedToKnow = ({
  info,
  heading,
  showTimeline
}: NeedToKnowProps) => {
  return (
    <div className="flex flex-col py-0 sm:py-5 gap-3 sm:gap-5 mb-3 sm:mb-0">
      <h2 className="text-black13 text-base sm:text-lg font-semibold">
        {heading}
      </h2>
      <div className="relative">
        {showTimeline && (
          <div className="absolute left-[5px] top-[15px] h-[calc(100%-30px)] w-[2px] bg-primary" />
        )}
        <ul className="relative">
          {info?.map((item: any, index: number) => {
            const content =
              typeof item === 'object' && item?.value ? item.value : item;
            return (
              <li
                key={index}
                className="text-black13 text-sm sm:text-base font-normal leading-normal mb-6 flex items-start pl-6 relative last:mb-0"
              >
                <div
                  className={`absolute left-0 top-[6px] rounded-full bg-primary ${
                    showTimeline ? 'w-3 h-3' : 'w-[6px] h-[6px]'
                  }`}
                />
                <span>{content}</span>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};
